import React, { useEffect, useState } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Snackbar,
  Alert,
  Box,
  Typography,
  Stack,
  Select,
  MenuItem,
  Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import NoDataFound from "../../common/NoDataFound";

import {
  getGroupCarrierAction,
  deleteCarrierByIdAction,
  searchCompanyGroupAction,
} from "../../redux/actions/agencyActions";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../loader/loader";
import { CustomTableCell } from "../../common/CustomTableCell";

const CarrierGroup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isSearchActive, setIsSearchActive] = useState(false);
 
  const [isSearching, setIsSearching] = useState(false);
  const [searchTrigger, setSearchTrigger] = useState(0);

  const [searchTerms, setSearchTerms] = useState({
    keyword: "",
    carrierName: "",
  });

  const isLoading = useSelector((state) => state.globalSearchReducer.loading);
  const permissions = useSelector(
    (state) => state.locationGroup.all_permission
  );
  const carrierDetails = useSelector((state) => state.agency.allGroupCarrier);
  const searchedCarrierList = useSelector(
    (state) => state?.agency?.get_carrier_list
  );

  const [keyword, setKeyword] = useState("");
  const [carrierName, setCarrierName] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const carriers = isSearchActive
    ? searchedCarrierList?.content || []
    : carrierDetails?.content || [];

  const totalElements = isSearchActive
    ? searchedCarrierList?.totalElements || 0
    : carrierDetails?.totalElements || 0;

  useEffect(() => {
    if (!isSearchActive) {
      dispatch(getGroupCarrierAction(page, rowsPerPage));
    }
  }, [page, rowsPerPage, isSearchActive, dispatch]);

  useEffect(() => {
    if (
      isSearchActive &&
      (searchTerms.keyword.trim() || searchTerms.carrierName.trim())
    ) {
      setIsSearching(true);
      dispatch(
        searchCompanyGroupAction(
          searchTerms.keyword.trim(),
          searchTerms.carrierName.trim(),
          page,
          rowsPerPage
        )
      )
        .then(() => {
          setIsSearching(false);
        })
        .catch(() => {
          setIsSearching(false);
        });
    }
  }, [
    dispatch,
    page,
    rowsPerPage,
    isSearchActive,
    searchTerms.keyword,
    searchTerms.carrierName,
    searchTrigger,
  ]);

  const handleSearch = () => {
    if (keyword.trim() || carrierName.trim()) {
      setPage(0);
      setIsSearchActive(true);
      setIsSearching(true);

      setSearchTerms({
        keyword: keyword.trim(),
        carrierName: carrierName.trim(),
      });
      setSearchTrigger((prev) => prev + 1);
    }
  };

  const handleReset = () => {
    setKeyword("");
    setCarrierName("");
    setSearchTerms({ keyword: "", carrierName: "" });
    setPage(0);
    setIsSearchActive(false);
    setIsSearching(false);
  };

  const handleAddNewClick = () => {
    navigate("/CreateCarrier");
  };

  const handleDeleteClick = (id) => {
    setSelectedGroupId(id);
    setOpenDialog(true);
  };

  const handleEditClick = (group) => {
    navigate("/CreateCarrier", {
      state: {
        group,
        isEdit: true,
      },
    });
    dispatch({ type: "CLEAR_CARRIER_LISTING_ITEM_SUCCESS" });
  };

  const handleConfirmDelete = async () => {
    if (selectedGroupId !== null) {
      setIsDeleting(true);

      try {
        await dispatch(deleteCarrierByIdAction(selectedGroupId));

        const currentItemsOnPage = carriers.length;
        const isLastItemOnPage = currentItemsOnPage === 1;
        const shouldGoToPreviousPage = isLastItemOnPage && page > 0;

        const newPage = shouldGoToPreviousPage ? page - 1 : page;

        if (shouldGoToPreviousPage) {
          setPage(newPage);
        } else {
          if (isSearchActive) {
            setIsSearching(true);
            try {
              await dispatch(
                searchCompanyGroupAction(
                  searchTerms.keyword,
                  searchTerms.carrierName,
                  newPage,
                  rowsPerPage
                )
              );
            } finally {
              setIsSearching(false);
            }
          } else {
            await dispatch(getGroupCarrierAction(newPage, rowsPerPage));
          }
        }

        setSnackbar({
          open: true,
          message: "Carrier group deleted successfully",
          severity: "success",
        });
      } catch (error) {
        console.error("Delete failed:", error);
        setSnackbar({
          open: true,
          message: "Failed to delete carrier group",
          severity: "error",
        });
      } finally {
        setIsDeleting(false);
        setOpenDialog(false);
        setSelectedGroupId(null);
      }
    }
  };

  const hasPermission = (code) => {
    return permissions.some((permission) => permission.code === code);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const totalPages = Math.ceil(totalElements / rowsPerPage);
  const showLoading = isLoading || isDeleting || isSearching;

 
  const renderNoDataFound = () => {
    if (!isSearchActive) {
      
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            backgroundColor: '#f9f9f9',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <NoDataFound
            discription="Please use the search filters above to fetch and display updated Carrier Group data."
            message="After click Search - results will be shown as per selected filter"
          />
        </Box>
      );
    } else if (carriers.length === 0) {
     
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            backgroundColor: '#f9f9f9',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <NoDataFound
            title="No Data Found"
            discription="Please change search filters where data is available as per defined criteria"
            message="After click Search - results will be shown as per selected filter"
          />
        </Box>
      );
    }
    return null;
  };

  return (
    <Paper
      sx={{
        margin: 2,
        padding: 2,
        border: "1px solid rgba(49, 49, 49, 0.1)",
        boxShadow: "0 4px 8px rgba(104, 104, 104, 0.1)",
      }}
    >
      <Box sx={{ padding: "16px" }}>
        <Box sx={{ padding: "2px" }}>
          <Typography
            variant="h2"
            sx={{
              ml: 1,
              mb: 2,
            }}
          >
              Carrier Group {isSearchActive && `(${totalElements})`}
          </Typography>
          
          {/* Search filters in a bordered container */}
          <Box mb={3} p={2} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
            <Box
              display="flex"
              alignItems="flex-end"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={2}
            >
              <Box display="flex" gap={2} flexWrap="wrap">
                <Box
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  gap={2}
                >
                  <Box display="flex" gap={2} flexWrap="wrap">
                    <Box display="flex" flexDirection="column">
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "19.6px",
                          textAlign: "left",
                          marginBottom: "4px",
                        }}
                      >
                        Search Term
                      </Typography>
                      <TextField
                        variant="outlined"
                        required
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        sx={{ width: 250, height: 56 }}
                        inputProps={{
                          style: { height: 56, boxSizing: "border-box" },
                        }}
                      />
                    </Box>

                    <Box display="flex" flexDirection="column">
                      <Typography
                        variant="body1"
                      >
                        Carrier Name
                      </Typography>
                      <TextField
                        variant="outlined"
                        value={carrierName}
                        onChange={(e) => setCarrierName(e.target.value)}
                        sx={{ width: 250, height: 56 }}
                        inputProps={{
                          style: { height: 56, boxSizing: "border-box" },
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

                <Button
                  variant="outlined"
                  onClick={handleSearch}
                  sx={{mt:3}}
                  disabled={
                    (keyword.trim().length === 0 && carrierName.trim().length === 0) || isSearching
                  }
                 
                >
                  {isSearching ? "Searching..." : "Search"}
                </Button>

                <Button
                sx={{mt:3}}
                  variant="outlined"
                  onClick={handleReset}
                  disabled={isSearching}
                >
                  Reset
                </Button>
              </Box>
              
              <Button
                variant="contained"
                onClick={handleAddNewClick}
              >
                Add Carrier Group
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Conditional rendering based on search state and data availability */}
        {!isSearchActive ? (
        
          renderNoDataFound()
        ) : carriers.length === 0 ? (
         
          renderNoDataFound()
        ) : (
         
          <TableContainer
            component={Paper}
            sx={{ position: "relative", minHeight: "200px" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="styled-table-heading">
                    Group Name
                  </TableCell>
                  <TableCell className="styled-table-heading">Status</TableCell>
                  <TableCell className="styled-table-heading">
                    Created By
                  </TableCell>
                  <TableCell className="styled-table-heading">
                    Created Date
                  </TableCell>
                  <TableCell className="styled-table-heading">
                    Updated By
                  </TableCell>
                  <TableCell className="styled-table-heading">
                    Last Update
                  </TableCell>
                  <TableCell className="styled-table-heading" align="right">
                    {hasPermission("ADD_CARRIER") && "Action"}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {showLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : (
                  carriers.map((group, index) => (
                    <TableRow className="styled-table-row" key={index}>
                      <TableCell>{group.name}</TableCell>
                      <TableCell>
                        {group.isActive ? "Active" : "Not Active"}
                      </TableCell>
                      <TableCell align="left">
                        {group.createdBy?.name || "-"}
                      </TableCell>
                      <CustomTableCell timestamp={group.createdBy?.timestamp} />
                      <TableCell align="left">
                        {group.updatedBy?.name || "-"}
                      </TableCell>
                      <CustomTableCell timestamp={group.updatedBy?.timestamp} />
                      <TableCell align="right">
                        <IconButton onClick={() => handleEditClick(group)}>
                          <EditIcon />
                        </IconButton>

                        <IconButton onClick={() => handleDeleteClick(group.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>

            {totalElements > 0 && !showLoading && (
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  padding: "16px 0",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={2}
                  sx={{
                    "@media (max-width: 600px)": {
                      flexDirection: "column",
                      alignItems: "center",
                    },
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "12px", marginRight: "8px" }}
                    >
                      Rows per page:
                    </Typography>
                    <Select
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      size="small"
                      sx={{ fontSize: "12px", minWidth: "80px" }}
                    >
                      {[5, 10, 15].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>

                  <Pagination
                    count={totalPages}
                    page={page + 1}
                    onChange={(event, value) =>
                      handleChangePage(event, value - 1)
                    }
                    showFirstButton
                    showLastButton
                    siblingCount={1}
                    boundaryCount={1}
                    size="small"
                  />
                </Stack>
              </Box>
            )}
          </TableContainer>
        )}

        <Dialog open={openDialog} onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } setOpenDialog(false); }}>
          <DialogTitle
            className="btn-primary"
            sx={{
              height: "64px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 16px",
            }}
          >
            {"Delete Confirmation"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ marginTop: "15px" }}>
              Are you sure you want to delete this carrier group? This action
              cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="btn-secondary"
              onClick={() => setOpenDialog(false)}
              color="primary"
              sx={{textTransform: 'none', fontSize: '15px',}}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary"
              onClick={handleConfirmDelete}
              color="error"
              autoFocus
              sx={{textTransform: 'none', fontSize: '15px',}}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>
      </Box>
    </Paper>
  );
};

export default CarrierGroup;